import React from 'react';
import { CopConference, CopConferenceSchema } from './useCopConferences';
import { EditItemProps } from '../../../toolympus/api/useNewItem';
import { useItemWithControls } from '../../../toolympus/api/useWithControls';
import { SimpleDialog, FormGrid } from '../../../toolympus/components/primitives';

interface Props extends Pick<EditItemProps<Partial<CopConference>>, "item" | "update" | "errors" | "save"> {
  isOpen: boolean;
  close: () => void;
  isCreate?: boolean;
}

export const CopConferenceEditDialog = (props: Props) => {
  const { isOpen, close, item, update, errors, save } = props;

  const { controls } = useItemWithControls(
    { data: item || {}, update, errors },
    { schema: CopConferenceSchema }
  );

  return (
    <SimpleDialog
      dialogTitle="COP Conference"
      submitOnModEnter
      noFullscreen
      close={close}
      isOpen={isOpen}
      save={save}
      maxWidth="md">

        {!!item && <>
        
          <FormGrid columns="1fr">
            {controls([
              ["title", { controlProps: { autoFocus: true } }],
            ])}
          </FormGrid>

          <FormGrid columns="1fr 1fr 1fr 1fr">
            {controls([
              ["sort_order"],
              ["color"],
              ["is_hidden"],
              ["image_url"],
              props.isCreate ? null : ["created_by", { disabled: true }],
              props.isCreate ? null : ["created_at", { disabled: true, utcToLocal: true }],
              props.isCreate ? null : ["updated_by", { disabled: true }],
              props.isCreate ? null : ["updated_at", { disabled: true, utcToLocal: true }],
            ])}
          </FormGrid>

          <FormGrid columns="1fr">
            {controls([
              ["description"],
            ])}
          </FormGrid>
        </>}


    </SimpleDialog>
  );
};